import { Badge, Card, CardBody } from 'reactstrap';

import { RelayTypeText } from '../../../helpers/enums/relayTypeEnum';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { ConnectionPhaseText } from '../../../helpers/enums/connectionPhaseEnum';

export default function RelayCard({ it, snapshot, onClick }) {
  const { t } = useTranslation();
  const [relayType, setRelayType] = useState(RelayTypeText[it.relayType]);

  return (
    <Card
      onClick={() => onClick(it)}
      className={`mb-2 ${snapshot.isDragging ? 'border border-dark bg-soft-info' : ''} ${it?.isDisabled ? 'opacity-50' : ''}`}
      style={{ minHeight: '1vh' }}
    >
      <CardBody className="p-0">
        <h6 className="pl-3 pt-3 pr-3 mb-2">{it.label}</h6>
        <div className="px-3 pb-2 d-flex justify-content-between">
          <div className="flex-fill">
            <span className="fs--1">{`#${it.idx}`}</span>
          </div>
          <div className="d-flex align-items-center">
            {it.protectionLabel && (
              <Badge
                color={'soft-primary'}
                style={{ width: '150px' }}
                className="ml-1 text-truncate"
              >
                {it.protectionLabel}
              </Badge>
            )}
            <Badge
              color="soft-dark"
              className="my-auto fs--1 font-weight-light ml-3"
              pill
            >
              {t(relayType)}
            </Badge>
            <Badge
              color="soft-primary"
              style={{ width: '50px' }}
              className="my-auto fs--1 font-weight-light ml-3"
              pill
            >
              {it.circuitsCount}
            </Badge>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
